import { IncidenceRepository } from "../repositories";
import { IncidenceResponse, IncidenceFilters, Incidence } from "../../interfaces/incidence.interface";

export class IncidenceProcess {
    private incidenceRepository: IncidenceRepository;

    constructor() {
        this.incidenceRepository = new IncidenceRepository();
    }

    async getIncidences(filters: IncidenceFilters): Promise<IncidenceResponse> {
        const response = await this.incidenceRepository.getIncidences(filters);
        const {
            data: { data, meta },
        } = response;
        return {
            data: data,
            meta: meta,
        };
    }
    async getIncidenceById(incidenceId: number): Promise<Incidence> {
        const response = await this.incidenceRepository.getIncidenceById(incidenceId);
        return response.data;
    }
    async getIncidenceStatus(): Promise<IncidenceResponse> {
        const response = await this.incidenceRepository.getIncidenceStatus();
        return {
            incidenceStatus: response.data,
        };
    }
    async getIncidenceVideos(incidenceId: number): Promise<IncidenceResponse> {
        const response = await this.incidenceRepository.getIncidenceVideos(incidenceId);
        return {
            incidenceVideos: response.data,
        };
    }
    async updateIncidenceStatus(updateData: { idIncidence: number; idStatus: number }): Promise<{ message: string }> {
        const response = await this.incidenceRepository.updateIncidenceStatus(updateData);
        const { data } = response;
        return { message: data.message };
    }
}
